export default function ContactHero() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] overflow-hidden flex items-center">
      {/* Background */}
      <div className="absolute inset-0 bg-[#061e45]">
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 70% 100% at 50% 50%, #1a5a9a 0%, #0d3a6e 35%, #061e45 70%, #030f24 100%)' }} />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d3b366]/30 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-[75px] w-full" style={{ paddingTop: '140px', paddingBottom: '60px' }}>
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 mb-6" aria-label="Breadcrumb">
          <a
            href="/"
            className="text-white/40 text-[11px] uppercase tracking-[0.18em] hover:text-white/70 transition-colors duration-200 cursor-pointer"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            Home
          </a>
          <span className="text-white/25 text-[11px]">/</span>
          <span
            className="text-[#d3b366] text-[11px] uppercase tracking-[0.18em]"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            Contact
          </span>
        </nav>
        <p
          className="text-[#d3b366] text-[10px] uppercase tracking-[0.3em] font-medium mb-6"
          style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
        >
          Get in Touch
        </p>
        <h1
          className="text-white text-4xl md:text-5xl lg:text-[64px] font-light leading-[1.05] mb-6 max-w-3xl"
          style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '-0.01em' }}
        >
          Find Out What
          <br />
          <em className="not-italic text-[#d3b366]">You&apos;re Actually Paying.</em>
        </h1>
        <p
          className="text-white/60 text-[15px] leading-relaxed max-w-xl"
          style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
        >
          Whether you&apos;re exploring options or ready to switch, we&apos;ll give you honest answers, clear numbers, and a plan that fits.
        </p>
      </div>
    </section>
  );
}